import styled, { css } from "styled-components";

export const Wrapper = styled.div(({ theme }) => css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  background-color: ${theme.palette.main.fieldWell};
  border-radius: 15px;

  .manage-repayment-pay-higher-button {
    margin: 15px 0 0;
    background-color: ${theme.buttons.secondary.background};
    color: ${theme.buttons.secondary.color};
    font-size: ${theme.buttons.fontSize};
    font-weight: ${theme.buttons.fontWeight};

    @media (hover: hover) {
      &:hover {
        color: ${theme.buttons.secondary.colorHover};
        background-color: ${theme.buttons.secondary.backgroundHover};
      }
    }
  }

  .manage-repayment-submit {
    align-self: flex-end;
  }
`);